import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoint } from './components/PainPoint';
import { TheProblem } from './components/TheProblem';
import { WhyItFailed } from './components/WhyItFailed';
import { TheSolution } from './components/TheSolution';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoItsFor } from './components/WhoItsFor';
import { HowItWorks } from './components/HowItWorks';
import { Results } from './components/Results';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-navy-900 text-slate-100 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoint data-id="element-3" />
        <TheProblem data-id="element-4" />
        <WhyItFailed data-id="element-5" />
        <TheSolution data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoItsFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Results data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}